import {
  ReactElement,
  ReactNode,
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import "./App.css";
import {
  Notification,
  Avatar,
  Badge,
  Form,
  Button,
  Dropdown,
  Layout,
  Nav,
  Space,
  Spin,
  Typography,
  Popover,
  Empty,
  Upload,
  Row,
  Col,
  Toast,
  Banner,
  Tag,
  Tooltip,
} from "@douyinfe/semi-ui";
import Section from "@douyinfe/semi-ui/lib/es/form/section";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  ApiClient,
  AppVersion,
  User,
  TeamManager,
  SwitchLogInReq,
  Lead,
  LeadMsg,
  TodoMsg,
  type Menu,
} from "./api/ApiClient";

import { NavItems, OnSelectedData } from "@douyinfe/semi-ui/lib/es/navigation";
import { beep, formatRelativeTime, maskMobile, meetRoles } from "./utils";
import {
  IconHistogram,
  IconLineChartStroked,
  IconAppCenter,
  IconCreditCard,
  IconDesktop,
  IconSetting,
  IconUserCircle,
  IconBell,
  IconMail,
  IconHelpCircle,
  IconMoon,
  IconPhoneStroke,
  IconDownload,
  IconDelete,
  IconFile,
  IconUser,
  IconList,
  IconAlertCircle,
  IconUserStroked,
  IconBookmark,
  IconHome,
  IconFaceuLogo,
  IconComment,

} from "@douyinfe/semi-icons";
import { FileItem } from "@douyinfe/semi-ui/lib/es/upload";
import watermark from "watermark-package";
import { Client, messageCallbackType } from "@stomp/stompjs";
import { TodoModal } from "./pages/todo/todoModal";
import { TodoCrud } from "./pages/todo/todoCrud";
import { TodoLoanCrud } from "./pages/todo/todoLoanCrud";
import { NavigationRouteProps } from "./Routes";
import navigationRoutes from "./Routes";
import { Tabs, TabPane } from "@douyinfe/semi-ui";
import NavigationTabPane, { NavigationTabPaneProps } from "./Navigation";
import { PageManual } from "./comp/PageManual";
import UserSwitchModal from "./comp/UserSwitchModal";
import {
  flatNavigationRoutes,
  getNavigationParentRoutes,
  getNavigationRouteInfo,
  updateFlatNavigationRoutes,
  HOME_PANE,
  FIRST_PANE,
} from "./util";
import pubsub from "pubsub-js";

const { Header, Sider, Content } = Layout;
let apiClient = ApiClient.getDefault();

export function App() {
  let nav = useNavigate();
  const routeMatch = useLocation();
  const selectedKeys = useMemo(
    () => [routeMatch?.pathname],
    [routeMatch.pathname.replace("/", "")]
  );
  const [refreshing, setRefreshing] = useState(false);
  let [admin, setAdmin] = useState<User>();
  let [showTodo, setShowTodo] = useState(false);
  let [showTodoLoan, setShowTodoLoan] = useState(false);
  let [badges, setBadges] = useState<Record<string, number>>({});
  const [panes, setPanes] = useState<NavigationTabPaneProps[]>([]);
  let [todoCount, setTodoCount] = useState<number>(0);
  let [bellColor, setBellColor] = useState<Record<string, string>>({});
  let [todoLoanCount, setTodoLoanCount] = useState<number>(0);
  let [bellLoanColor, setBellLoanColor] = useState<Record<string, string>>({});
  const [attachments, setAttachments] = useState([] as FileItem[]);
  const [attachmentsWgt, setAttachmentsWgt] = useState([] as FileItem[]);
  const [images, setImages] = useState([] as FileItem[]);
  let [appDownloadUrl, setAppDownloadUrl] = useState("");
  let [appQrcodeUrl, setAppQrcodeUrl] = useState("");
  let [popoverVisible, setPopoverVisible] = useState(false);
  let [appVersion, setAppVersion] = useState<AppVersion>();
  const [appSaving, setAppSaving] = useState(false);
  let [teamManagers, setTeamManagers] = useState([] as TeamManager[]);
  const [userSwitchVisible, setUserSwitchVisible] = useState(false);
  const [userSwitch, setUserSwitch] = useState(false);

  /** 更新扁平化路由数组 */
  updateFlatNavigationRoutes(navigationRoutes);

  const navigationHandler = useCallback(
    (routeInfo: NavigationRouteProps & { url: string }) => {
      // console.log(routeInfo);

      setPanes((p) => {
        if (!p.find((item) => item.tabKey === routeInfo.url)) {
          const pane: NavigationTabPaneProps = {
            tab: routeInfo.name,
            tabKey: routeInfo.url,
            path: routeInfo.path,
          };

          return p.concat(pane);
        }

        return p;
      });
    },
    []
  );

  /**
   * 点击menu时 生成新的tab页面或跳转到已存在的tab页面
   */
  const onNavigate = useCallback(
    (info: any) => {
      //console.log(info.itemKey);
      const routeInfo = getNavigationRouteInfo(
        info.itemKey,
        flatNavigationRoutes
      );
      console.log(routeInfo);
      if (routeInfo) {
        if (routeInfo.openInNewWindow) {
          window.open(`#/${routeInfo.path}`, "_blank");
          return;
        }
        navigationHandler({ ...routeInfo, url: routeInfo.path });

        nav(routeInfo.path);
        //history.push(routeInfo.path);

        //菜单的标注
        apiClient.clearBadge(info.itemKey);
        getBadges();
      }
    },
    [navigationHandler]
  );

  /**
   * 关闭tab页面
   */
  const onTabClose = useCallback(
    (targetKey: any) => {
      //console.log(targetKey);

      const newPanes = panes.filter((item) => item.tabKey !== targetKey);
      let newActiveKey = routeMatch.pathname.replace("/", "");

      if (targetKey === routeMatch.pathname.replace("/", "")) {
        if (newPanes && newPanes.length > 0) {
          const removeIndex = panes.findIndex(
            (item) => item.tabKey === targetKey
          );

          const newIndex = removeIndex === 0 ? 0 : removeIndex - 1;
          newActiveKey = newPanes[newIndex].tabKey;
        } else {
          newActiveKey = "";
        }
      }

      setPanes(newPanes);
      nav(newActiveKey, { replace: true });
    },
    [routeMatch.pathname.replace("/", ""), panes]
  );

  /**
   * 点击tab栏切换tab页面
   */
  const onTabChange = useCallback((key: any) => {
    nav(key, { replace: true, state: { key } });
  }, []);

  const getBadgeCount = (key: string) => {
    return badges[key];
  };
  const initWs = (user: User) => {
    const routes: Record<string, messageCallbackType> = {};
    routes["/lead/" + user.id] = (msg) => {
      if (!msg.body) {
        return;
      }
      const lead: LeadMsg = JSON.parse(msg.body);
      if ("newLoan" == lead.msgType) {
        Notification.open({
          title: "有按揭客户",
          content: lead.name,
          duration: 0,
        });
        localStorage.setItem("my-loan-refresh", "true");
        localStorage.setItem("team-loan-refresh", "true");
        //  publish 发布消息 消息名为：name 内容为：
        pubsub.publish("refreshMenuCount", "");
        beep();

      } else {
        Notification.open({
          title: lead.assignCount >= 2 ? "有再分配客户" : "有我的客户",
          content: lead.name,
          duration: 0,
        });
        localStorage.setItem("new-refresh", "true");
        localStorage.setItem("my-refresh", "true");
        localStorage.setItem("fav-refresh", "true");
        localStorage.setItem("team-refresh", "true");
        //  publish 发布消息 消息名为：name 内容为：
        pubsub.publish("refreshMenuCount", "");
        if (lead.assignCount <= 2) {
          beep();
        }

        getBadges();
      }
    };

    routes["/todo/" + user.id] = (msg) => {
      if (!msg.body) {
        return;
      }
      const todo: TodoMsg = JSON.parse(msg.body);
      if (todo.todoMsgType == 3) {
        setTodoCount(todo.todoCount);
        if (todo.todoCount > 0) {
          setBellColor({ color: "#E91E63" });
        } else {
          setBellColor({});
        }
      } else if (todo.todoMsgType == 4) {
        setTodoLoanCount(todo.todoCount);
        if (todo.todoCount > 0) {
          setBellLoanColor({ color: "#E91E63" });
        } else {
          setBellLoanColor({});
        }
      } else if (todo.todoMsgType == 5) {
        setBannerVisible(true);
        setBannerDesc(todo.content);
      } else {
        Notification.open({
          title: formatRelativeTime(todo.dueDate),
          content: todo.content,
          duration: 0,
        });
      }

      //beep();
    };

    routes["/refreshLead/" + user.id] = (msg) => {
      console.log("收到服务端刷新客户列表消息");
      const lead: LeadMsg = JSON.parse(msg.body);
      if (lead.msgType == null || lead.msgType == undefined) {
        localStorage.setItem("new-refresh", "true");
        localStorage.setItem("my-refresh", "true");
        localStorage.setItem("fav-refresh", "true");
        localStorage.setItem("team-refresh", "true");
        localStorage.setItem("pool-refresh", "true");
      } else {
        if (lead.msgType.includes("new-refresh")) {
          localStorage.setItem("new-refresh", "true");
        }
        if (lead.msgType.includes("my-refresh")) {
          localStorage.setItem("my-refresh", "true");
        }
        if (lead.msgType.includes("fav-refresh")) {
          localStorage.setItem("fav-refresh", "true");
        }
        if (lead.msgType.includes("team-refresh")) {
          localStorage.setItem("team-refresh", "true");
        }
        if (lead.msgType.includes("pool-refresh")) {
          localStorage.setItem("pool-refresh", "true");
        }
      }

      //  publish 发布消息 消息名为：name 内容为：
      pubsub.publish("refreshMenuCount", "");
    };

    const client = apiClient.getWsClient(routes);
    client.activate();
  };
  let toLogin = () => {
    //获取浏览器访问的IP
    let ip = window.location.host;
    if("47.109.154.206" == ip){
      nav("/login", { replace: true });
    }else{
      nav("/login", { replace: true });
    }
    
  };
  let handleLogout = async () => {
    await apiClient.logout();
    await apiClient.clearToken();
    let token = await apiClient.fetchToken();
    apiClient.setToken(token.data);
    toLogin();
  };

  let handleUserSwitch = async (username: string, password: string) => {
    try {
      // 1. 先退出当前账号
      await apiClient.logout();
      await apiClient.clearToken();

      // 2. 用新账号登录
      let token = await apiClient.fetchToken();
      apiClient.setToken(token.data);
      await apiClient.logIn({
        mobile: username,
        password: password,
        captcha: "webnot",
        otp: "",
      });
      let user = await apiClient.getCurrentAdmin();
      localStorage.setItem("username", user.data.username);
      localStorage.setItem("userId", String(user.data.id));
      localStorage.setItem("userRealName", user.data.name);
      localStorage.setItem("teamId", String(user.data.teamId));
      localStorage.setItem("teamName", user.data.teamName);
      localStorage.setItem("role", user.data.role);
      localStorage.setItem("city", user.data.city);

      // 3. 刷新页面
      Toast.success({ content: `已切换到 ${username}`, duration: 2 });
      setUserSwitchVisible(false);
      location.reload();
    } catch (e: any) {
      console.error("切换用户失败:", e);
      Toast.error({ content: e.message || "切换用户失败", duration: 3 });
      // 切换失败时重新加载，恢复原状态
      location.reload();
    }
  };
  let getAdmin = async () => {
    try {
      await apiClient.initToken();
      let admin = (await apiClient.getCurrentAdmin()).data;
      setAdmin(admin);
      //默认打开的菜单

      if (admin && admin.menus[0].menus[0]) {
        if(admin.menus[0].menus[0].code === "aiChat"){
          onNavigate({ itemKey: admin.menus[1].menus[0].code });
        }else{
          onNavigate({ itemKey: admin.menus[0].menus[0].code });
        }
        
      } else {
        onNavigate({ itemKey: "saleNewLeads" });
      }
      watermark.setWaterMark({
        w_texts: [admin.name, maskMobile(admin.mobile) || ""],
      });
      initWs(admin);
    } catch (e) {
      toLogin();
    }
  };

  const getAppVersion = async () => {
    let appV = (await apiClient.getAppVersion()).data;
    setAppVersion(appV);
    setAppQrcodeUrl(appV.appQrcodeUrl);
    setAppDownloadUrl(appV.appDownloadUrl);
  };

  const getBadges = async () => {
    const badges = await apiClient.getBadges();
    setBadges(badges);
  };

  const getMyTeamManagers = async () => {
    const datas = await apiClient.getMyTeamManagers();
    setTeamManagers(datas);
  };

  const getTodoCount = async () => {
    const cnt = await apiClient.getTodoCount();
    setTodoCount(cnt);
    if (cnt > 0) {
      setBellColor({ color: "#E91E63" });
    } else {
      setBellColor({});
    }
  };

  const getTodoLoanCount = async () => {
    const cnt = await apiClient.getTodoLoanCount();
    setTodoLoanCount(cnt);
    if (cnt > 0) {
      setBellLoanColor({ color: "#E91E63" });
    } else {
      setBellLoanColor({});
    }
  };

  let refreshMenuinterval: any = useRef();
  useEffect(() => {
    if (!apiClient.getToken()) {
      toLogin();
      return;
    }

    const body = document.body;
    let themeMode = localStorage.getItem("theme-mode");
    if(themeMode == "dark"){
      body.setAttribute("theme-mode", "dark")
    }

    getBadges();
    getTodoCount();
    getTodoLoanCount();
    getAdmin();
    getAppVersion();
    getMyTeamManagers();
    loadAppAtttachment();

    if(admin?.username === "zhangtao"  || localStorage.getItem("loginFrom") ==="zhangtao"){
        setUserSwitch(true);
    }

    //开启定时器
    refreshMenuinterval.current = setInterval(() => refreshMenuCount(), 60000);
    let refreshMenuCount = async () => {
      console.log("刷新菜单数量：", new Date().toLocaleTimeString());
      let admin = (await apiClient.getCurrentAdmin()).data;
      setAdmin(admin);
      getTodoCount();
      getTodoLoanCount();
    };

    // 订阅消息 消息名：name  第二个参数是一个函数
    // 此函数又有两个参数：消息名和消息数据,消息名不可以省略,可以是用_占位
    let pubsubRefreshMenuCount = pubsub.subscribe(
      "refreshMenuCount",
      (_: any, res: any) => {
        console.log(
          "发布和订阅---刷新菜单数量：",
          new Date().toLocaleTimeString()
        );
        refreshMenuCount();
      }
    );

    return () => {
      console.log("离开页面------------");
      // 在组件卸载前执行 相当于componentWillUnmount
      // 在此做一些收尾工作, 比如清除定时器/取消订阅等
      pubsub.unsubscribe(pubsubRefreshMenuCount);

      // 清除定时器
      clearInterval(refreshMenuinterval.current);
    };
  }, []);

  // useEffect(() => {
  //   return () => {
  //     console.log("离开页面------------");
  //     // 清除定时器
  //     clearInterval(refreshMenuinterval);

  //      // 在此做一些收尾工作, 比如清除定时器/取消订阅等
  //      pubsub.unsubscribe(token)
  //   };
  // }, []);

  let mapToIcon = (icon: string): ReactNode => {
    switch (icon) {
      case "user":
        return <IconUserCircle />;
      case "card":
        return <IconCreditCard />;
      case "desktop":
        return <IconDesktop />;
      case "app":
        return <IconAppCenter />;
      case "setting":
        return <IconSetting />;
      case "chart":
        return <IconHistogram />;
      case "index":
        return <IconHome />;
      case "aiChat":
        return <IconFaceuLogo />;
      case "aiCoachChat":
        return <IconComment />;
      case "homeDashboard":
        return <IconHistogram />;
      default:
        return null;
    }
  };

  let getNavItems = (): NavItems => {
    return (
      admin?.menus
        .filter((m) => m.menus.length > 0)
        .map((m) => {
          return {
            itemKey: m.code,
            text: m.name,
            icon: mapToIcon(m.icon),
            items: m.menus.map((i) => {
              return {
                itemKey: i.code,
                icon: <Badge type="danger" count={getBadgeCount(i.code)} />,
                text: getMenuText(i),
              };
            }),
          };
        }) || []
    );
  };

  let getMenuText = (i: Menu) => {
    if (i.count == -1) {
      return i.name;
    } else if (i.countTodo == -1) {
      return (
        <span>
          {i.name}
          <Badge type="primary" theme="light" count={i.count} />
        </span>
      );
    } else {
      return (
        <span>
          {i.name}
          <Badge type="danger" theme="solid" count={i.countTodo} />
          <Badge type="primary" theme="light" count={i.count} />
        </span>
      );
    }
  };

  let getDefaultMenuKey = () => {
    for (var i = 0; i < admin!.menus.length; i++) {
      if (admin!.menus[i].menus && admin!.menus[i].menus.length > 0) {
        return admin!.menus[i].menus[0].code;
      }
    }
    return "";
  };

  const switchMode = () => {
    const body = document.body;
    if (body.hasAttribute("theme-mode")) {
      body.removeAttribute("theme-mode");
      localStorage.setItem("theme-mode", "light");
    } else {
      body.setAttribute("theme-mode", "dark");
      localStorage.setItem("theme-mode", "dark");
    }
  };

  const switchTableMode = () => {
    let tableMode = localStorage.getItem("table-mode");
    if (tableMode == "NoSticky") {
      localStorage.setItem("table-mode", "sticky");
    } else {
      localStorage.setItem("table-mode", "NoSticky");
    }
    //刷新页面
    window.location.reload();
  };

  const loadAppAtttachment = () => {
    apiClient.getAttachmentLocals(0).then((a) => {
      let appFiles: FileItem[] = a.filter((item) => {
        return item.response == "app";
      });
      let wgtFiles: FileItem[] = a.filter((item) => {
        return item.response == "wgt";
      });
      let appQrcodes: FileItem[] = a.filter((item) => {
        return item.response == "qrcode";
      });
      setAttachments(appFiles);
      setAttachmentsWgt(wgtFiles);
      setImages(appQrcodes);
    });
  };

  const afterUpload = (e: any) => {
    // 可以根据业务接口返回，决定当次上传是否成功
    if (e.response.code != "ok") {
      return {
        autoRemove: false,
        status: "uploadFail",
        validateMessage: "内容不合法",
        name: "RenameByServer.jpg",
      };
    } else {
      loadAppAtttachment();
      return {};
    }
  };

  const renderFileOperation = (fileItem: FileItem) => (
    <div style={{ display: "flex", columnGap: 8, padding: "0 8px" }}>
      <Button
        icon={<IconDownload />}
        type="tertiary"
        theme="borderless"
        size="small"
        onClick={async () => {
          if (fileItem.url) {
            window.open(fileItem.url, "_blank");
          } else {
            let url = await apiClient.getAttachmentLocalDownUrl(
              fileItem.uid as any
            );
            window.open(url, "_blank");
          }
        }}
      ></Button>

      <Button
        onClick={async () => {
          let resp = await apiClient.deleteAttachmentLocal(fileItem.uid as any);
          if (resp.code == "ok") {
            fileItem.onRemove();
          }
        }}
        icon={<IconDelete></IconDelete>}
        type="tertiary"
        theme="borderless"
        size="small"
      ></Button>
    </div>
  );

  const syncValidate: any = (values: any) => {
    let flag = true;
    const errors = {};
    if (images.length == 0) {
      Toast.info("请上传下载二维码");
      flag = false;
    }
    if (attachments.length == 0) {
      Toast.info("请上传APP升级包或更新包");
      flag = false;
    }

    if (flag) {
      return null;
    } else {
      return errors;
    }
  };

  let handleSwitchAccountAuth = async (userId: number) => {
    let logInDto = {} as SwitchLogInReq;
    logInDto.userId = userId;
    try {
      await apiClient.switchAccountLogIn(logInDto);
      let user = await apiClient.getCurrentAdmin();
      localStorage.setItem("userId", String(user.data.id));
      localStorage.setItem("username", user.data.username);
      localStorage.setItem("userRealName", user.data.name);
      localStorage.setItem("teamId", String(user.data.teamId));
      localStorage.setItem("teamName", user.data.teamName);
      localStorage.setItem("role", user.data.role);
      localStorage.setItem("city", user.data.city);
      let page = getDefaultMenuKeyByUser(user.data);
      console.log("page ", "login");
      // nav("/" + page, { replace: true });
      location.reload();
    } catch (e) {
      console.error("登录错误", e);
    }
  };

  let getDefaultMenuKeyByUser = (admin: User) => {
    for (var i = 0; i < admin.menus.length; i++) {
      if (admin.menus[i].menus && admin.menus[i].menus.length > 0) {
        return admin.menus[i].menus[0].code;
      }
    }
  };

  const [bannerVisible, setBannerVisible] = useState(false);
  const [bannerDesc, setBannerDesc] = useState("流量池今日新客上限告警");
  const changeBannerVisible = () => {
    setBannerVisible(!bannerVisible);
  };

  const banner = (
    <Banner
      type="danger"
      onClose={changeBannerVisible}
      description={bannerDesc}
    />
  );


  let mainPage = () => (
    <Layout className="components-layout-demo">
      <Header style={{ backgroundColor: "var(--semi-color-bg-1)", padding: 0 }}>
        <Nav
          mode="horizontal"
          defaultSelectedKeys={[getDefaultMenuKey()]}
          header={{
            logo: (
                <img src="/mis/webcast_logo.svg" />
            ),
            text: (
              <span style={{ fontWeight: 600, fontSize: 16, color: 'var(--semi-color-text-0)', whiteSpace: 'nowrap' }}>
                CRM 客户关系管理系统
              </span>
            ),
          }}
          style={{ borderBottom: 'none' }}
        >
          <Nav.Footer>
            <div className="app-header-toolbar">
              <Tooltip content="切换夜间/白天模式" position="bottom">
                <Button
                  theme="borderless"
                  icon={<IconMoon style={{ color: 'rgba(var(--semi-indigo-6), 1)' }} size="large" />}
                  onClick={() => switchMode()}
                />
              </Tooltip>
              <Tooltip content="切换固定表头模式" position="bottom">
                <Button
                  theme="borderless"
                  icon={<IconList style={{ color: 'rgba(var(--semi-indigo-6), 1)' }} size="large" />}
                  onClick={() => switchTableMode()}
                />
              </Tooltip>
              <Tooltip content="AI助手" position="bottom">
                <Button
                  theme="borderless"
                  icon={<IconFaceuLogo style={{ color: '#E91E63' }} size="large" />}
                  onClick={() => { onNavigate({ itemKey: "aiChat" }); }}
                />
              </Tooltip>
              <Tooltip content="提醒事项" position="bottom">
                <Badge count={todoCount} type="danger">
                  <Button
                    theme="borderless"
                    icon={<IconBell style={bellColor} size="large" />}
                    onClick={() => setShowTodo(true)}
                  />
                </Badge>
              </Tooltip>
              <Tooltip content="按揭提醒" position="bottom">
                <Badge count={todoLoanCount} type="danger">
                  <Button
                    theme="borderless"
                    icon={<IconMail style={bellLoanColor} size="large" />}
                    onClick={() => setShowTodoLoan(true)}
                  />
                </Badge>
              </Tooltip>
              {true && (
                <Popover
                  trigger="click"
                  content={
                    <Empty
                      title={"拨号助手下载二维码"}
                      image={appQrcodeUrl}
                      description="使用手机浏览器扫码下载安装"
                      style={{ width: 600, margin: "0 auto", display: "flex", padding: 20 }}
                    >
                      <Button
                        style={{ width: "200px" }}
                        theme="solid"
                        type="primary"
                        onClick={async () => { window.open(appDownloadUrl, "_blank"); }}
                      >
                        点击下载APP
                      </Button>

                      {(admin?.username === "zhangtao") && (
                        <div style={{ marginTop: 50 }}>
                          <Form<AppVersion>
                            validateFields={syncValidate}
                            labelAlign="right"
                            labelWidth={100}
                            labelPosition="left"
                            initValues={appVersion}
                            render={(form) => {
                              const handleAppSubmit = async () => {
                                setAppSaving(true);
                                try {
                                  setAppSaving(false);
                                  await form.formApi.validate();
                                  await apiClient.request(
                                    "/attachment/app/publish",
                                    "POST",
                                    null,
                                    { ...form.formApi.getValues() }
                                  );
                                  getAppVersion();
                                  Toast.info("发布成功");
                                } catch (e) {
                                  console.log(e);
                                  setAppSaving(false);
                                }
                              };

                              const style = { width: "100%" };
                              return (
                                <Row gutter={15}>
                                  <Section text="APP发布">
                                    <Row>
                                      <Col span={12}>
                                        <Form.Select style={style} field="publishType" label="发布类型">
                                          <Form.Select.Option key="wgt" value="wgt">热更新</Form.Select.Option>
                                          <Form.Select.Option key="app" value="app">APP升级</Form.Select.Option>
                                        </Form.Select>
                                      </Col>
                                      <Col span={12}>
                                        <Form.Input style={style} field="appVersion" label="发布版本" />
                                      </Col>
                                      <Col span={12}>
                                        <Form.Input style={style} field="wgtVersion" label="热更新版本" />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <Form.TextArea style={style} field="updateIntro" label="更新内容" />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <Form.Slot label="APP安装包">
                                          <Upload
                                            onChange={(props) => setAttachments(props.fileList)}
                                            showClear={false}
                                            previewFile={() => (<IconFile size="large" />)}
                                            fileList={attachments}
                                            renderFileOperation={renderFileOperation}
                                            name="file"
                                            headers={{ "X-Auth-Token": apiClient.getToken()!! }}
                                            action={apiClient.getAttachmentLocalFieldUploadUrl("app", 0)}
                                            afterUpload={afterUpload}
                                            draggable
                                            dragMainText={"点击上传文件或拖拽文件到这里"}
                                            style={style}
                                          />
                                        </Form.Slot>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <Form.Slot label="APP更新包">
                                          <Upload
                                            onChange={(props) => setAttachmentsWgt(props.fileList)}
                                            showClear={false}
                                            previewFile={() => (<IconFile size="large" />)}
                                            fileList={attachmentsWgt}
                                            renderFileOperation={renderFileOperation}
                                            name="file"
                                            headers={{ "X-Auth-Token": apiClient.getToken()!! }}
                                            action={apiClient.getAttachmentLocalFieldUploadUrl("wgt", 0)}
                                            afterUpload={afterUpload}
                                            draggable
                                            dragMainText={"点击上传文件或拖拽文件到这里"}
                                            style={style}
                                          />
                                        </Form.Slot>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <Form.Slot label="下载二维码">
                                          <Upload
                                            onChange={(props) => setImages(props.fileList)}
                                            showClear={false}
                                            previewFile={() => (<IconFile size="large" />)}
                                            fileList={images}
                                            renderFileOperation={renderFileOperation}
                                            name="file"
                                            headers={{ "X-Auth-Token": apiClient.getToken()!! }}
                                            action={apiClient.getAttachmentLocalFieldUploadUrl("qrcode", 0)}
                                            afterUpload={afterUpload}
                                            draggable
                                            dragMainText={"点击上传文件或拖拽文件到这里"}
                                            style={style}
                                          />
                                        </Form.Slot>
                                      </Col>
                                    </Row>
                                  </Section>
                                  <Row type="flex" justify="center">
                                    <Button onClick={handleAppSubmit} loading={appSaving} style={{ width: 200 }}>确认发布</Button>
                                    <Button theme="solid" onClick={async () => { beep(); }}>播放</Button>
                                  </Row>
                                </Row>
                              );
                            }}
                          />
                        </div>
                      )}
                    </Empty>
                  }
                >
                  <Button
                    theme="borderless"
                    icon={<IconPhoneStroke size="large" />}
                    onClick={() => { setPopoverVisible(!popoverVisible); }}
                  />
                </Popover>
              )}
              {/* 用户区域 */}
              <div className="app-header-user">
                <Dropdown
                  clickToHide
                  position="bottomRight"
                  render={
                    <Dropdown.Menu style={{ width: 250 }}>
                      {teamManagers.map((manager) => (
                        <Dropdown.Item key={manager.userId} icon={<IconUser />} type="primary" onClick={() => handleSwitchAccountAuth(manager.userId)}>
                          {manager.name}-{manager?.roleName}({manager?.city})
                        </Dropdown.Item>
                      ))}
                      <Dropdown.Item>{admin?.totp ? "已绑验证器" : "未绑验证器"}</Dropdown.Item>
                      <Dropdown.Item onClick={() => setShowTodo(true)}>提醒事项</Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item onClick={handleLogout}>退出</Dropdown.Item>
                    </Dropdown.Menu>
                  }
                >
                  <Avatar color="orange" size="small">
                    {admin!.name.substring(0, 2).toUpperCase()}
                  </Avatar>
                </Dropdown>
                <span
                  style={{
                    cursor: userSwitch ? "pointer" : "default",
                    color: userSwitch ? "var(--semi-color-primary)" : "inherit",
                  }}
                  onClick={() => {
                    if (userSwitch) {
                      setUserSwitchVisible(true);
                    }
                  }}
                >
                  {admin?.name}
                  {userSwitch && (
                    <span style={{ fontSize: 10, marginLeft: 4, opacity: 0.7 }}>▼</span>
                  )}
                </span>
                <Tag size="small" shape="circle">{admin?.roleName}</Tag>
              </div>
            </div>
          </Nav.Footer>
        </Nav>
      </Header>
      {/* 用户切换弹窗 - 仅 zhangtao 可见 */}
      {userSwitch && (
        <UserSwitchModal
          visible={userSwitchVisible}
          onClose={() => setUserSwitchVisible(false)}
          onSwitch={handleUserSwitch}
        />
      )}
      {bannerVisible && banner}
      <Layout>
        <Sider>
          <Nav
            footer={{ collapseButton: true }}
            defaultSelectedKeys={[window.location.hash.replace("#/", "")]}
            style={{ minHeight: "100%" }}
            items={getNavItems()}
            onSelect={onNavigate}
          />
        </Sider>
        <Content>
          <Tabs
            type="line"
            collapsible
            activeKey={routeMatch.pathname.replace("/", "")}
            onChange={onTabChange}
            onTabClose={onTabClose}
          >
            {panes.map((pane) => (
              <TabPane
                {...pane}
                itemKey={pane.tabKey}
                key={pane.path}
                closable={true}
              >
                <NavigationTabPane
                  {...pane}
                  key={pane.path}
                  refreshing={refreshing && pane.tabKey === routeMatch.pathname.replace("/", "")}
                  navigateTo={onNavigate}
                />
              </TabPane>
            ))}
          </Tabs>
          <PageManual />
        </Content>
      </Layout>
    </Layout>
  );

  let loadingPage = (
    <div className="app-loading-page">
      <Typography.Title heading={3} style={{ color: 'var(--semi-color-text-2)' }}>
        CRM 客户关系管理系统
      </Typography.Title>
      <Spin size="large" />
    </div>
  );

  return admin ? (
    <>
      <TodoCrud onCancel={() => setShowTodo(false)} visible={showTodo} />
      <TodoLoanCrud onCancel={() => setShowTodoLoan(false)} visible={showTodoLoan} />
      {mainPage()}
    </>
  ) : (
    loadingPage
  );
}
